import { InquiryData } from "pages/application/applicationService";

/* eslint-disable */

export const trackOPTVOAStepLoaded = () => {
  window.optimizely = window.optimizely || [];
  window.optimizely.push({ type: "page", pageName: "application_voa_step" });
};

export const trackOPTOptedVoa = () => {
  window.optimizely.push({
    type: "event",
    eventName: "opted_voa",
  });
};

export const trackOPTVoaCompleted = () => {
  window.optimizely.push({
    type: "event",
    eventName: "voa_completed",
  });
};

const getPropertyType = (value: number | undefined) => {
  switch (value) {
    case 1:
      return "singlefamilyhome";
    case 2:
      return "twofourfamilyhome";
    case 3:
      return "condo";
    default:
      return;
  }
};

const getPropertyUsageType = (value: number | undefined) => {
  switch (value) {
    case 1:
      return "primary";
    case 2:
      return "second";
    case 3:
      return "investment";
    default:
      return;
  }
};
export const trackOptUserData = (inquiryData: InquiryData, loanPurpose: string, path: string, leadProvider: string) => {
  window.optimizely = window.optimizely || [];
  window.optimizely.push({
    type: "user",
    attributes: {
      loanpurpose: loanPurpose,
      leadprovider: leadProvider,
      creditscore: inquiryData.creditScore,
      leadcampaign: inquiryData.leadCampaign,
      purchaseprice: inquiryData.mappings.find((mapping) => mapping.stepCode?.toUpperCase() == "B9")?.value,
      loanamount: inquiryData.mappings.find((mapping) => mapping.keyName?.toLowerCase() == "purchasepropertyloanamount")?.value,
      loandownpaymentamount: inquiryData.mappings.find((mapping) => mapping.keyName?.toLowerCase() == "purchasepropertydownpaymentdollar")?.value,
      loandownpaymentpercent: inquiryData.mappings.find((mapping) => mapping.keyName?.toLowerCase() == "purchasepropertydownpaymentpercent")?.value,
      loanofficerassigned: inquiryData.loanOfficerAssigned ?? "Not Assigned",
      loanofficertype: inquiryData.loanOfficerType,
      pathselection: path,
      propertytype: getPropertyType(inquiryData.mappings.find((mapping) => mapping.stepCode?.toUpperCase() == "B7")?.value as number),
      propertyusage:
        loanPurpose?.toLowerCase() == "purchase"
          ? getPropertyUsageType(inquiryData.mappings.find((mapping) => mapping.stepCode?.toUpperCase() == "B8")?.value as number)
          : getPropertyUsageType(inquiryData.mappings.find((mapping) => mapping.stepCode?.toUpperCase() == "B3")?.value as number),
      signedcontract: inquiryData.mappings.find((mapping) => mapping.stepCode?.toUpperCase() == "B4")?.value,
    },
  });
};
